var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.464 137.462C112.072 140.448 109.527 142.68 106.515 142.68H73.4021C70.3946 142.68 67.8517 140.453 67.4546 137.472L60.2154 83.1247C59.6431 78.8277 63.6936 75.2871 67.9318 76.1977C74.2428 77.5536 82.855 79.0039 90.224 78.8285C97.5696 78.6536 105.96 77.2434 112.092 75.9918C116.272 75.1386 120.195 78.6368 119.639 82.8668L112.464 137.462Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.674 123.83C112.674 123.83 102.013 131.034 89.8643 131.034C77.7159 131.034 67.0547 123.83 67.0547 123.83",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotsIcon);
export default __webpack_public_path__ + "static/media/shots-icon.ce49de3cc298adfc9982b306c5af1c83.svg";
export { ForwardRef as ReactComponent };